<template>
  <div>
    <b-modal
      id="voucher-generate-cards"
      :title="`${editInfo ? 'Update Voucher Card' : 'Generate Voucher Cards'}`"
      ok-variant="success"
      :ok-title="`${editInfo ? 'Update' : 'Generate'}`"
      :no-close-on-backdrop="generatingCards"
      :no-close-on-esc="generatingCards"
      :hide-header-close="generatingCards"
      :ok-disabled="generatingCards"
      @ok="submit"
    >
      <b-overlay :show="vendorsLoading">
        <validation-observer ref="generateCardsRef">
          <b-form>
            <template v-if="!editInfo">
              <b-form-group
                label="Vendor"
                label-for="cards-vendor"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Vendor"
                  rules="required"
                >
                  <b-form-select
                    id="cards-vendor"
                    v-model="cardsBatch.vendorId"
                    :options="vendors"
                    :state="errors.length > 0 ? false:null"
                    text-field="name"
                    value-field="id"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="User Type"
                label-for="cards-user Type"
              >
                <validation-provider
                  #default="{ errors }"
                  name="User Type"
                  rules="required"
                >
                  <b-form-select
                    id="cards-user Type"
                    v-model="cardsBatch.userType"
                    :options="userTypes"
                    :state="errors.length > 0 ? false:null"
                    text-field="name"
                    value-field="id"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
              </b-form-group>
              <validation-provider
                #default="{ errors }"
                name="No. Of Cards"
                rules="required"
              >
                <b-form-group
                  label="No. Of Cards"
                  label-for="cards-count"
                >
                  <b-form-input
                    id="cards-count"
                    v-model.number="cardsBatch.numberOfCards"
                    type="number"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="{ errors }"
                name="Amount Per Card"
                rules="required"
              >
                <b-form-group
                  label="Amount Per Card"
                  label-for="cards-amount"
                >
                  <b-form-input
                    id="cards-amount"
                    v-model.number="cardsBatch.amountPerCard"
                    type="number"
                  />
                  <span class="text-danger">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </template>
            <validation-provider
              #default="{ errors }"
              name="Expiry Date"
              rules="required"
            >
              <b-form-group
                label="Expiry Date"
                label-for="cards-expiry"
              >
                <b-form-datepicker
                  id="cards-expiry"
                  v-model="cardsBatch.expiryDate"
                  :min="new Date()"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </b-form-group>
            </validation-provider>
            <template
              v-if="editInfo"
            >
              <b-form-checkbox v-model="cardsBatch.active">
                Status
              </b-form-checkbox>
            </template>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormDatepicker, BFormSelect, BOverlay, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import useGenerateCards from '../hooks/useGenerateCards'

export default {
  components: {
    BOverlay,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    editInfo: {
      type: Object,
      default: null,
    },
  },
  setup(props, ctx) {
    return {
      ...useGenerateCards(props, ctx),
      required,
    }
  },
}
</script>

<style>

</style>
